<template lang="html">
<div>
    <v-container>
      <v-card>
        <v-container>
          <v-row justify="center">
            <v-col cols="12" class="text-center">
            <div class="title">{{full_name}}</div>
            </v-col>
          </v-row>
        <v-row justify="center">
          <v-col cols="12" md="8" class="pb-0" v-if="contracts != null && contracts != '' && customer_id != null">
            <v-select
              v-model="contract_id"
              :items="contracts"
              item-text="contract_name"
              item-value="contract_id"
              label="Szerződés választása"
              solo
            >
              <template v-slot:selection="data">
                <!-- HTML that describe how select should render selected items -->
                {{ data.item.contract_name }} - {{ data.item.contract_date }}
              </template>
              <template v-slot:item="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ data.item.contract_name }} - {{ data.item.contract_date }} ({{data.item.contract_type}})
              </template>
            </v-select>
            </v-col>
            </v-row>
            <v-row>
            <v-col class="text-center" cols="12">
            <v-btn
              rounded
              @click="createContract"
              color="primary"
              v-if="customer_id"
            >
            Szerződés hozzáadása
            <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            </v-col>
          </v-row>
          <v-expansion-panels v-if="contracts != null && contracts != '' && customer_id != null">
          <v-expansion-panel>
            <v-expansion-panel-header>Szerződés adatai</v-expansion-panel-header>
            <v-expansion-panel-content>
          <v-row justify="center" v-if="contract_id">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="contract_date"
                label="Szerződéskötés ideje"
                outlined
                :disabled="!admin"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="contract_place"
                label="Szerződéskötés helye"
                outlined
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="driving_school"
                :items="driving_school_options"
                label="Iskola"
                outlined
                disabled
              ></v-select>
            </v-col>
          </v-row>
          <v-row justify="center" v-if="contract_id">
            <v-col cols="12" md="4">
              <v-select
                v-model="course_type"
                :items="course_type_options"
                label="Képzés típusa"
                outlined
                :disabled='student_course_details != ""'
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="contract_type"
                :items="contract_type_options"
                label="Szerződés típusa"
                outlined
                :disabled='student_course_details != ""'
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="registry_code"
                label="Nyilvántartási szám"
                outlined
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="course_type == 3">
            <v-col cols="12" md="4">
              <v-select
                v-model="mentesseg_oka"
                :items="mentesseg_options"
                label="Tanfolyammentesség oka"
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8" v-if="contract_type == 4">
              <v-select
                v-model="gki_category_contract"
                :items="gki_category_list_contract"
                item-text="nev"
                item-value="pallasz_id"
                label="GKI alkategória"
                outlined
                :loading="loading"
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" v-if="contract_type != 4">
              <v-select
                v-model="nyelv"
                :items="nyelv_select"
                label="Nyelv"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="esigno"
                label="Elektronikus aláírás ideje"
                outlined
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" v-if="contract_type != 4">
              <v-text-field
                v-model="parent_signo"
                label="Szülői aláírás ideje"
                outlined
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="contract_status"
                :items="contract_status_options"
                label="Státusz"
                outlined
              ></v-select>
            </v-col>
            <v-col v-if="contract_status" cols="12" md="4">
              <v-menu
                ref="status_menu"
                v-model="status_date_menu"
                :close-on-content-click="false"
                :return-value.sync="status_date"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="status_date"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                    :disabled="contract_status == 'Megfelelt'"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="status_date" no-title scrollable first-day-of-week=1>
                  <div class="flex-grow-1"></div>
                  <v-btn text color="primary" @click="status_date_menu = false">Mégsem</v-btn>
                  <v-btn text color="primary" @click="$refs.status_menu.save(status_date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="prefered_office_id"
                :items="office_list"
                item-text="place_name"
                item-value="training_place_id"
                label="Ügyintézés helye"
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" v-if="contract_id">
            <v-col cols="6" md="3">
              <v-btn
                color="primary"
                rounded
                @click="modify_contract_dialog = true"
              >
              Módosít
              </v-btn>
            </v-col>
            <v-col cols="6" md="3">
            <v-btn
              color="red"
              dark
              @click="archvie_contract_dialog = true"
              rounded
            >
            Töröl
            </v-btn>
            </v-col>
            <v-col cols="6" md="3">
            <v-btn
              color="green"
              dark
              rounded
              @click="getContractDetails()"
              outlined
            >
            Frissít
            </v-btn>
            </v-col>
            <v-col cols="6" md="3" v-if="admin">
              <v-checkbox
                v-model="sign_alert"
                label="aláírás értesítés tiltása"
                @change="disableSignAlert()"
              ></v-checkbox>
            </v-col>
          </v-row>
          </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
        <br>
        <v-layout justify-center>
        <v-slide-group
          v-model="diakok_tab"
          show-arrows
          mandatory
        >
        <v-slide-item v-slot:default="{ active, toggle }">
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Személyes adatok</span>
            <v-icon>perm_contact_calendar</v-icon>
          </v-btn>
        </v-slide-item>
        <v-slide-item v-if="customer_id" v-slot:default="{ active, toggle }">
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Vezetői engedély</span>
            <v-icon>picture_in_picture</v-icon>
          </v-btn>
        </v-slide-item>
        <v-slide-item v-if="contract_id" v-slot:default="{ active, toggle }">
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Tanfolyamok</span>
            <v-icon>school</v-icon>
          </v-btn>
        </v-slide-item>
        <v-slide-item v-if="contract_id" v-slot:default="{ active, toggle }">
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Vizsgák</span>
            <v-icon>date_range</v-icon>
          </v-btn>
        </v-slide-item>
        <v-slide-item v-if="contract_id" v-slot:default="{ active, toggle }">
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Gyakorlat</span>
            <v-icon>drive_eta</v-icon>
          </v-btn>
        </v-slide-item>
        <v-slide-item v-if="contract_id" v-slot:default="{ active, toggle }">
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Befizetések</span>
            <v-icon>attach_money</v-icon>
          </v-btn>
        </v-slide-item>
        </v-slide-group>
      </v-layout>
      <br>
        <DiakAdatok v-show="diakok_tab == 0"></DiakAdatok>
        <DiakLicense v-show="diakok_tab == 1" v-if="customer_id"></DiakLicense>
        <DiakTanfolyam v-show="diakok_tab == 2" v-if="contract_id"></DiakTanfolyam>
        <DiakVizsga v-show="diakok_tab == 3" v-if="contract_id"></DiakVizsga>
        <DiakGyakorlat v-show="diakok_tab == 4" v-if="contract_id"></DiakGyakorlat>
        <DiakBefizetes v-show="diakok_tab == 5" v-if="contract_id"></DiakBefizetes>

      </v-card>
    </v-container>

    <v-dialog v-model="create_contract" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Szerződés létrehozása</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="create_contract_form"
              v-model="valid"
            >
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  ref="dt_menu"
                  v-model="date_menu"
                  :close-on-content-click="false"
                  :return-value.sync="new_contract_date"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="new_contract_date"
                      label="Szerződéskötés ideje"
                      append-icon="event"
                      readonly
                      outlined
                      v-on="on"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="new_contract_date" no-title scrollable first-day-of-week=1>
                    <div class="flex-grow-1"></div>
                    <v-btn text color="primary" @click="date_menu = false">Mégsem</v-btn>
                    <v-btn text color="primary" @click="$refs.dt_menu.save(new_contract_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="username"
                  label="Szerződéskötés helye"
                  outlined
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="new_driving_school"
                  :items="driving_school_options"
                  label="Iskola"
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="category"
                  :items="category_list"
                  item-text="contract_name"
                  item-value="nkh_course_type_id"
                  label="Kategória választása"
                  outlined
                  :loading="loading"
                  :disabled="!new_driving_school"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="gki_category"
                  :items="gki_category_list"
                  item-text="nev"
                  item-value="pallasz_id"
                  label="GKI alkategória"
                  outlined
                  :loading="loading"
                  v-if="category == 27 || category == 28 || category == 29 || category == 30 || category == 31 || category == 78 || category == 79 || category == 80"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="new_course_type"
                  :items="course_type_options"
                  label="Képzés típusa"
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="new_contract_type"
                  :items="contract_type_options"
                  label="Szerződés típusa"
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" v-if="new_course_type == 3">
                <v-select
                  v-model="mentesseg_oka_new"
                  :items="mentesseg_options"
                  label="Tanfolyammentesség oka"
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="create_contract = false, resetValidation()">Mégsem</v-btn>
          <v-btn color="primary" text @click="saveContract(), create_contract = false" :disabled="!valid">Létrehozás</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="archvie_contract_dialog" persistent max-width="420">
      <v-card v-if="student_course_details == ''">
        <v-card-text class="pt-4">Biztosan törölni szeretné a szerződést?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteContract(), archvie_contract_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="archvie_contract_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="student_course_details != ''">
        <v-card-text class="pt-4">A szerződéshez aktív tanfolyam tartozik, így nem törölhető!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="archvie_contract_dialog = false">Bezár</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modify_contract_dialog" persistent max-width="330">
      <v-card>
        <v-card-text class="pt-4">Biztosan módosítani szeretné a szerződést?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="updateContract(), modify_contract_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="modify_contract_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="delete_contract_snackbar" bottom>
      {{delete_contract_response}}
      <v-btn color="pink" text @click="delete_contract_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="save_contract_snackbar" bottom :color="response_success == 'error' ? 'error' : ''">
      {{save_contract_response}}
      <v-btn :color="response_success == 'error' ? '' : 'pink'" text @click="save_contract_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

</div>
</template>

<script>
import DiakAdatok from '../components/diakok_adatok.vue'
import DiakGyakorlat from '../components/diakok_gyakorlat.vue'
import DiakVizsga from '../components/diakok_vizsga.vue'
import DiakTanfolyam from '../components/diakok_tanfolyam.vue'
import DiakBefizetes from '../components/diakok_payments.vue'
import DiakLicense from '../components/diakok_license.vue'
import DiakJellap from '../components/diakok_jellap.vue'
import store from '../store'

import {
  mapFields
} from 'vuex-map-fields'

  export default {
    components: {
      DiakAdatok,
      DiakGyakorlat,
      DiakVizsga,
      DiakTanfolyam,
      DiakBefizetes,
      DiakLicense,
      DiakJellap
    },
    data () {
      return {
        loading: false,
        contracts: '',
        contract_date: '',
        contract_place: '',
        driving_school: '',
        driving_school_options: [
          { text: 'Csigavér 01. Autósiskola Kft', value: 1},
          { text: 'Csigavér 02. Kft', value: 2},
        ],
        course_type_options: [
          { text: 'tantermi', value: 1},
          { text: 'e-learning', value: 2},
          { text: 'tanfolyammentes', value: 3},
        ],
        contract_type_options: [
          { text: 'GKI szerződés', value: 4},
          { text: 'Felnőttképzési szerződés', value: 5},
          { text: 'Gyakorló vezetés', value: 6},
        ],
        mentesseg_options: [
          { text: 'Átvett tanuló', value: 1},
          { text: 'Honosítás', value: 2},
          { text: 'Gyakorló vezetés', value: 6},
          { text: 'Kategória bővítés', value: 3},
          { text: 'Automatáról manuális váltóra', value: 5},
        ],
        nyelv_select: [
          { text: 'Magyar', value: null},
          { text: 'Angol', value: 'angol'},
        ],
        nyelv: null,
        registry_code: '',
        create_contract: false,
        new_contract_date: new Date().toISOString().substr(0, 10),
        new_driving_school: '',
        new_course_type: '',
        new_contract_type: '',
        date_menu: false,
        category: '',
        category_list: [],
        save_contract_response: '',
        save_contract_snackbar: false,
        archvie_contract_dialog: false,
        modify_contract_dialog: false,
        delete_contract_response: '',
        delete_contract_snackbar: false,
        contract_status: '',
        contract_status_options: [
          { text: ''},
          { text: 'Megfelelt'},
          { text: 'Elment'},
          { text: 'Elévült'},
          { text: 'Áthelyezés alatt - Petzvál'},
          { text: 'Áthelyezés alatt - Szigetszentmiklós'},
        ],
        status_date_menu: false,
        status_date: '',
        valid: true,
        rules: {
            required: value => !!value || 'Kötelező mező!',
          },
        response_success: '',
        gki_category_list: [],
        gki_category: '',
        gki_category_contract: '',
        gki_category_list_contract: [],
        prefered_office_location_id: '',
        esigno: '',
        parent_signo: '',
        mentesseg_oka: '',
        mentesseg_oka_new: '',
        sign_alert: '',
        office_list: [],
        prefered_office_id: '',
      }
    },
    methods: {
      getContractList: async function() {
        this.gki_category_contract = null
        store.state.showing.preloader = true
        this.contracts = null
        await this.gettoken()
        this.$http.post('/diakok/contract_list', {
          token: this.token,
          customer_id: this.customer_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.contracts = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      getCategoryList: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/category_list', {
          token: this.token,
          school_id: this.new_driving_school
        }).then((response) => {
          this.loading = false
          this.category_list = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      getOfficeList: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/portal_office', {
          token: this.token
        }).then((response) => {
          this.loading = false
          this.office_list = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getGKICategoryList: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/gki_category_list', {
          token: this.token,
          category: this.category
        }).then((response) => {
          this.loading = false
          this.gki_category_list = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getGKICategoryListContract: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/gki_category_list_contract', {
          token: this.token,
          nkh_course_type_id: this.nkh_course_type_id
        }).then((response) => {
          this.loading = false
          this.gki_category_list_contract = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getContractDetails: async function() {
        this.gki_category_contract = null
        store.state.showing.preloader = true
        this.contract_status = null
        this.status_date = null
        this.nyelv = null
        await this.gettoken()
        this.$http.post('/diakok/contract_details_250220', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.contract_date = response.data[0]['contract_date']
          this.contract_place = response.data[0]['place']
          this.prefered_office_location_id = response.data[0]['prefered_office_location_id']
          this.prefered_office_id = response.data[0]['prefered_location_id']
          this.driving_school = response.data[0]['school_id']
          this.course_type = response.data[0]['type']
          this.contract_type = response.data[0]['template']
          this.registry_code = response.data[0]['registry_code']
          this.nkh_course_type_id = response.data[0]['course_type_key']
          this.contract_status = response.data[0]['status']
          this.titanId = response.data[0]['etitan_id']
          this.status_date = response.data[0]['status_date']
          this.nyelv = response.data[0]['nyelv']
          this.esigno = response.data[0]['contract_sign_time']
          this.parent_signo = response.data[0]['parent_sign_time']
          this.mentesseg_oka = response.data[0]['mentesseg_oka']
          this.sign_alert = response.data[0]['disable_sign']
          if (response.data[0]['gki_cat_key'] != null) {
            this.gki_category_contract = response.data[0]['gki_cat_key'].toString()
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      createContract() {
        this.create_contract = true
        this.new_contract_date = new Date().toISOString().substr(0, 10)
        this.new_driving_school = null
        this.new_course_type = null
        this.new_contract_type = null
        this.category = null
        this.mentesseg_oka_new = null
      },
      saveContract: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/save_contract_20250220', {
          token: this.token,
          school_id: this.new_driving_school,
          category_code: this.category,
          place_id: this.placeid,
          course_type: this.new_course_type,
          contract_type: this.new_contract_type,
          customer_id: this.customer_id,
          gki_category_contract: this.gki_category,
          mentesseg_oka: this.mentesseg_oka_new
        }).then((response) => {
          store.state.showing.preloader = false
          this.getContractList()
          this.contract_id = response.data['id']
          this.save_contract_response = response.data['message']
          this.response_success = response.data['result']
          this.save_contract_snackbar = true
        }, (error) => {
          console.log(error.data);
        })
      },
      updateContract: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/update_contract_20260819', {
          token: this.token,
          course_type: this.course_type,
          contract_type: this.contract_type,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          contract_status: this.contract_status,
          status_date: this.status_date,
          contract_date: this.contract_date,
          gki_category_contract: this.gki_category_contract,
          mentesseg_oka: this.mentesseg_oka,
          prefered_office_id: this.prefered_office_id,
          nyelv: this.nyelv
        }).then((response) => {
          store.state.showing.preloader = false
          this.getContractList()
          this.getContractDetails()
          this.save_contract_response = response.data
          this.save_contract_snackbar = true
        }, (error) => {
          console.log(error.data);
        })
      },
      deleteContract: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/delete_contract', {
          token: this.token,
          contract_id: this.contract_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.delete_contract_response = response.data
          this.getContractList()
          this.contract_id = ''
          this.delete_contract_snackbar = true

        }, (error) => {
          console.log(error.data);
        })
      },
      disableSignAlert: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/disable_contSign', {
          token: this.token,
          sign_alert: this.sign_alert,
          contract_id: this.contract_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.getContractDetails()
          this.save_contract_response = response.data
          this.save_contract_snackbar = true
        }, (error) => {
          console.log(error.data);
        })
      },
      validate () {
        this.$refs.create_contract_form.validate()
        },
      reset () {
        this.$refs.create_contract_form.reset()
      },
      resetValidation() {
        this.$refs.create_contract_form.resetValidation()
      },
    },
    mounted() {
      this.getOfficeList()
      if (this.customer_id) {
        this.getContractList()
        this.getContractDetails()
      }
    },
    watch: {
      customer_id: function (value) {
        if (value != null) {
          this.getContractList()
        }
      },
      contract_id: function (value) {
        if (value != null) {
        this.getContractDetails()
        }
      },
      new_driving_school: function (value) {
        this.getCategoryList()
      },
      new_contract_type: function (value) {
        if (value == 6) {
          this.new_course_type = 3
        }
      },
      category: function (value) {
        this.new_contract_type = null
        this.new_course_type = null
        if (value == 27 || value == 28 || value == 29 || value == 30 || value == 31 || value == 78 || value == 79 || value == 80) {
          this.getGKICategoryList()
          this.new_contract_type = 4
          this.contract_type_options.forEach((item, index) => {
            if (item.value == 4) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
          });
          console.log(this.contract_type_options);
        } else if (value == 2 || value == 5 || value == 6) {
          this.new_course_type = 3
          this.new_contract_type = 5
          this.contract_type_options.forEach((item, index) => {
            if (item.value == 4) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
          });
          console.log(this.contract_type_options);
        } else {
          this.contract_type_options.forEach((item, index) => {
            if (item.value == 4) {
              item.disabled = true;
            } else {
              item.disabled = false;
            }
          });
          console.log(this.contract_type_options);
        }
      },
      contract_type: function (value) {
        if (value == 6) {
          this.course_type = 3
        }
      },
      course_type: function (value) {
        if (value == 1 || value == 2) {
          //this.contract_type = 5
        }
      },
      nkh_course_type_id() {
        this.getGKICategoryListContract()
      }
    },
    computed: {
    ...mapFields([
      'showing.DiakokDetails_show',
      'showing.preloader',
      'diakok_details.customer_id',
      'diakok_details.contract_id',
      'diakok_details.contract_type',
      'diakok_details.course_type',
      'diakok_details.student_course_details',
      'diakok_details.diakok_tab',
      'diakok_details.full_name',
      'diakok_details.titanId',
      'auth.loginuser',
      'auth.username',
      'auth.admin',
      'auth.placeid',
      'course_details.course_id',
      'course_details.course_student_id',
      'course_details.nkh_course_type_id',
  ]),
  },
  }
</script>

<style lang="css">
</style>
